import React, { useCallback, useRef } from "react";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FormValidation from "../../components/FormValidation/FormValidation";
import formFields from "../../config/formFields.json";

const AddActivity = ({
    open,
    onClose,
    initialData = null,
    onSubmit,
    tags = [],
    onDependencyChange,
    tagsByType = []
}) => {
    const isEdit = !!initialData;

    const initialValues = {
        activity_name: initialData?.activity_name || "",
        tag_type: initialData?.tag_type || "",
        tag_id: initialData?.tags
            ? (
                // If tags is already array of objects with tag_id, extract ids
                Array.isArray(initialData.tags) && typeof initialData.tags[0] === "object"
                    ? initialData.tags.map((tag) => tag.tag_id?.toString())
                    :
                    // If tags is array of string/number ids, convert to strings
                    Array.isArray(initialData.tags)
                        ? initialData.tags.map((id) => id?.toString())
                        : []
            )
            : [],
    };

    const getOptionsForField = useCallback(
        (source) => {
            switch (source) {
                case "tag_id":
                    return [
                        { value: "all", label: "All" },
                        ...(tagsByType?.map((tag) => ({
                            value: tag.tag_id.toString(),
                            label: tag.tag_name,
                        })) || []),
                    ];
                default:
                    return [];
            }
        },
        [
            tagsByType
        ]
    );


    const handleSubmit = async (formData) => {
        let tagIds = [];
        if (Array.isArray(formData.tag_id)) {
            if (formData.tag_id.includes("all")) {
                // Expand 'all' to all tag IDs for the selected tag_type
                tagIds = tagsByType
                    .filter(tag => tag.tag_type === formData.tag_type)
                    .map(tag => Number(tag.tag_id));
            } else {
                tagIds = formData.tag_id.map((id) => Number(id));
            }
        }
        const transformedData = {
            ...formData,
            tag_id: tagIds,
        };
        try {
            await onSubmit(transformedData);
        } catch (error) {
            console.error("Error submitting form: in Add Activity OnSubmit", error);
            throw new Error(error.message);
        }
    };

    return (
        <FormValidation
            open={open}
            onClose={onClose}
            initialData={initialValues}
            onSubmit={handleSubmit}
            formFields={formFields.activity.basic.fields}
            title="Activity"
            icon={AssignmentIcon}
            getOptionsForField={getOptionsForField}
            isEdit={isEdit}
            modelWidth={"55vw"}
            onDependencyChange={onDependencyChange}
        />
    );
};

export default AddActivity;
